// © 2025 COPYright LAHO – https://www.linkedin.com/in/laurens-holtkamp-7a686b2b/
import { supabase } from '../lib/supabase';

const MAX_LABEL_LENGTH = 120;
const MAX_PATH_LENGTH = 240;

const safeText = (value, max = MAX_LABEL_LENGTH) =>
  String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, max);

export const isSuperAdminUser = (user) => {
  const configuredEmails = (process.env.REACT_APP_SUPER_ADMIN_EMAILS || '')
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);
  const configuredIds = (process.env.REACT_APP_SUPER_ADMIN_USER_IDS || '')
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);

  if (!user) return false;
  return (
    configuredEmails.includes((user.email || '').toLowerCase()) ||
    configuredIds.includes(user.id)
  );
};


export const fetchIsSuperAdmin = async (user) => {
  if (!user?.id) return false;

  if (isSuperAdminUser(user)) return true;

  const { data, error } = await supabase
    .from('app_super_admins')
    .select('user_id')
    .eq('user_id', user.id)
    .maybeSingle();

  if (error) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('Super-admin status niet opgehaald:', error.message);
    }
    return false;
  }

  return !!data;
};

export const trackAnalyticsEvent = async ({
  eventName,
  user,
  groupId = null,
  metadata = {},
}) => {
  if (!user?.id || !eventName) return;

  const payload = {
    event_name: safeText(eventName, 80),
    user_id: user.id,
    group_id: groupId,
    path: safeText(window.location.pathname, MAX_PATH_LENGTH),
    metadata,
    user_agent: safeText(window.navigator.userAgent, 300),
  };

  const { error } = await supabase.from('analytics_events').insert(payload);
  if (error && process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn('Analytics event niet opgeslagen:', error.message);
  }
};

export const describeClickedElement = (element) => {
  const clickable = element?.closest?.('button, a, [role="button"], input[type="submit"]');
  if (!clickable) return null;

  return {
    tag: clickable.tagName?.toLowerCase(),
    label: safeText(
      clickable.getAttribute('aria-label') ||
        clickable.getAttribute('title') ||
        clickable.innerText ||
        clickable.value ||
        clickable.name ||
        'Onbekende knop'
    ),
    href: safeText(clickable.getAttribute('href') || '', MAX_PATH_LENGTH),
  };
};
